module.exports = __webpack_public_path__ + "img/kt-preceptorylogos.d0b50723.png";